import { render, staticRenderFns } from "./SetsSettings.vue?vue&type=template&id=5b69391e&scoped=true"
import script from "./SetsSettings.vue?vue&type=script&lang=js"
export * from "./SetsSettings.vue?vue&type=script&lang=js"
import style0 from "./SetsSettings.vue?vue&type=style&index=0&id=5b69391e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69391e",
  null
  
)

export default component.exports